import {Action, handleActions} from 'redux-actions';
import {
    SnackbarDequeuedPayload,
    SnackbarEnqueuedPayload,
    snackbarDequeued,
    snackbarEnqueued,
} from '../action/snackbarEvents';
import {allTenantDependentDataCleared} from '../action/authenticationEvents';

export interface Snackbar {
    id: string;
    severity: 'error'|'warning'|'info'|'success';
    message: string;
    autoHideDuration: number;
}

export interface SnackbarState {
    snackbars: Snackbar[];
}

export const initialState: SnackbarState = {
    snackbars: [],
};

/* eslint-disable max-len */
export const reducer = handleActions<SnackbarState, any>(
    {
        [snackbarEnqueued.toString()]: (state = initialState, action: Action<SnackbarEnqueuedPayload>): SnackbarState => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                snackbars: [...state.snackbars, {
                    id: action.payload.id,
                    severity: action.payload.severity,
                    message: action.payload.message,
                    autoHideDuration: action.payload.autoHideDuration || 3500,
                }],
            };
        },
        [snackbarDequeued.toString()]: (state = initialState, action: Action<SnackbarDequeuedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                snackbars: state.snackbars.filter(snackbar => snackbar.id !== action.payload.id),
            };
        },
        [allTenantDependentDataCleared.toString()]: (state = initialState, action: Action<{}>) => {
            return {
                ...initialState,
            };
        },
    },
    initialState,
);
